import { api } from 'services/companiesApi';

export const getAccessManagement = async (filters?: any) => {
	const dataParams = { ...filters };
	return await api.get('/access-management', {
		params: dataParams,
	});
};

export const postProfile = async (data: any) => {
	return await api.post('/roles', data);
};
